import API_ENDPOINTS from '../api/endpoint';
import apiClient from '../api/apiClient';

export const fetchUserProfile = async (id) => {
  try {
    const endpoint = id
      ? API_ENDPOINTS.USERS.PROFILE(id)  // Fetch by ID
      : API_ENDPOINTS.USERS.PROFILE();  // Fetch logged-in user (Fix: Add `()`)

    const response = await apiClient.get(endpoint);
    return response.data;
  } catch (error) {
    console.error(`Error fetching user profile for ID: ${id}`, error);
    throw error;
  }
};

export const editUserProfile = async (formData) => {
  try {
    const response = await apiClient.patch(API_ENDPOINTS.USERS.EDIT_PROFILE, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error updating user profile:', error?.response?.data || error);
    throw error;
  }
};

export const profilePhotoUpload = async (formdata) => {
  try {
    const response = await apiClient.post(API_ENDPOINTS.USERS.PHOTO_UPLOAD, formdata, {
      headers: {
        "Content-Type": "multipart/form-data", // Explicitly set the content type for form data
      },
    });
    return response;
  } catch (error) {
    console.error("Error uploading profile image", error);
    throw error; // Re-throw the error for the caller to handle
  }
};